import React, { useEffect } from 'react';
import './App.css';
import "react-quill/dist/quill.snow.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
import ApiGateway from './helper/ApiGateway';
import UnAvailableWindow from './helper/UnAvailableWindow';
import pkg from "../package.json";
import CacheBuster from 'react-cache-buster';
import MaintenanceAlertDialog from './containers/MaintenanceAlertDialog';
import CareersLandingPage from './containers/LandingPage/CareersLandingPage';

const App = () => {
  window.onload = () => {
    window.addEventListener("beforeunload", (e) => {
      // Cancel the event

      e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      // sessionStorage.removeItem("_token_employee")
      // sessionStorage.removeItem("RegistrationId")
      e.returnValue = "";
    });
  };
  const isProduction = process.env.NODE_ENV === "production";
  useEffect(() => {
    ApiGateway.checkServiceAvailable();
  }, [])
  return (
    <CacheBuster
      currentVersion={pkg.version}
      isEnabled={isProduction} // If false, the library is disabled.
      isVerboseMode={false} // If true, the library writes verbose logs to console.
      metaFileDirectory="."
    >
      <div>
        <UnAvailableWindow>
        </UnAvailableWindow>
        <MaintenanceAlertDialog />
        {/* <CareersLandingPage></CareersLandingPage> */}
        <CareersLandingPage />
        {/* <MainPage /> */}
      </div>
    </CacheBuster>
  )
}
export default App;
